import { colors, Icon, iconSizes, mixin } from "@hubrise/react-components"
import styled from "styled-components"

export const StyledDealLine = styled.div`
  display: flex;
  flex-direction: column;
`

export const Label = styled.div`
  white-space: nowrap;
  font-weight: 500;
  margin-bottom: 0.25rem;
`

export const Expandable = styled.div`
  margin-left: -1rem;
  margin-right: -1rem;
`

export const Toggle = styled.div`
  position: absolute;
  top: 0.25rem;
  right: 1rem;
  padding: 0.5rem;
  border-radius: 50%;
  ${mixin.clickable};

  :hover {
    background-color: ${colors.backgroundLighter};
  }
`

export const ToggleIcon = styled(Icon).attrs({ size: iconSizes._20 })``
